<!-- Leads -> Opportunities -> Won funnel, reused for a single campaign and for a
     category's rollup — see CampaignsCRM.vue. -->
<template>
  <div>
    <small
      v-if="label"
      class="text-muted d-block mb-1"
    >{{ label }}</small>
    <div class="cm-funnel">
      <div class="cm-funnel__step">
        <strong>{{ stats.leadsCount }}</strong><span>Leads</span>
      </div>
      <feather-icon
        icon="ArrowRightIcon"
        size="14"
        class="cm-funnel__arrow"
      />
      <div class="cm-funnel__step">
        <strong>{{ stats.opportunitiesCount }}</strong><span>Opportunities</span>
      </div>
      <feather-icon
        icon="ArrowRightIcon"
        size="14"
        class="cm-funnel__arrow"
      />
      <div class="cm-funnel__step">
        <strong>{{ stats.wonCount }}</strong><span>Won ({{ money(stats.wonValue) }})</span>
      </div>
    </div>
    <div
      v-if="stats.costPerLead !== null || stats.roi !== null"
      class="cm-roi"
    >
      <span v-if="stats.costPerLead !== null">Cost/lead: {{ money(stats.costPerLead) }}</span>
      <span
        v-if="stats.roi !== null"
        :class="{ 'text-danger': stats.roi < 0, 'text-success': stats.roi >= 0 }"
      >ROI: {{ stats.roi }}%</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignFunnel',
  props: {
    stats: { type: Object, required: true },
    money: { type: Function, required: true },
    label: { type: String, default: '' },
  },
}
</script>

<style scoped>
.cm-funnel { display: flex; align-items: center; gap: .5rem; background: #fafafa; border-radius: .4rem; padding: .6rem; margin-bottom: .5rem; }
.cm-funnel__step { text-align: center; flex: 1; }
.cm-funnel__step strong { display: block; font-size: 1.1rem; }
.cm-funnel__step span { font-size: .68rem; color: #6e6b7b; }
.cm-funnel__arrow { color: #ccc; flex-shrink: 0; }
.cm-roi { display: flex; gap: 1rem; font-size: .8rem; font-weight: 600; margin-bottom: .6rem; }
</style>
